module.exports = __webpack_public_path__ + "static/20190427_134847(0)_optimized-33430062071360e2611f8cdb388fbe14.jpg";